const columnsTodo = [
  {
    title: '工单ID',
    fixed: 'left',
    dataIndex: 'workOrderId',
    key: 'workOrderId',
    slots: { customRender: 'workOrderId' },
    width: 180
  },
  {
    title: '被分配次数',
    dataIndex: 'allocatedNum',
    width: 150,
    sorter: true
  },
  {
    title: '提醒人',
    dataIndex: 'reminder',
    key: 'reminder',
    slots: { customRender: 'reminder' },
    width: 150
  },
  {
    title: '工单任务',
    dataIndex: 'eventContent',
    key: 'eventContent',
    slots: { customRender: 'eventContent' },
    width: 250
  },
  {
    title: '工单类型',
    width: 160,
    dataIndex: 'businessTypeDesc',
    key: 'businessTypeDesc'
  },
  {
    title: '工单状态',
    dataIndex: 'workOrderStatusDesc',
    key: 'workOrderStatusDesc',
    width: 100
  },
  {
    title: '状态标签',
    dataIndex: 'stateTagDesc',
    width: 100
  },
  {
    title: '转交状态',
    dataIndex: 'transferFlagDesc',
    key: 'transferFlagDesc',
    width: 100
  },
  {
    title: '有效状态',
    dataIndex: 'isValid',
    key: 'isValid',
    width: 100,
    customRender({ text }) {
      if (text === null) return '--'
      return text ? '有效' : '无效'
    }
  },
  {
    title: '当前处理人',
    dataIndex: 'acceptorName',
    key: 'acceptorName',
    width: 150
  },
  {
    title: '创建时间',
    width: 135,
    dataIndex: 'createdAt',
    key: 'createdAt',
    sorter: true
  },
  {
    title: '分配时间',
    width: 135,
    dataIndex: 'startTime',
    key: 'startTime',
    sorter: true
  },
  {
    title: '处理时间',
    width: 135,
    dataIndex: 'dealTime',
    key: 'dealTime',
    sorter: true
  },
  {
    title: '结束时间 ',
    width: 135,
    dataIndex: 'completeTime',
    key: 'completeTime',
    slots: { customRender: 'completeTime' },
    sorter: true
  },
  {
    title: '操作',
    key: 'handle',
    dataIndex: 'handle',
    fixed: 'right',
    width: 120,
    slots: { customRender: 'handle' }
  }
]
// 处方下拉选
const prescriptionOption = [
  {
    value: 0,
    label: '全部'
  },
  {
    value: 1,
    label: '未购买'
  },
  {
    value: 2,
    label: '已购买'
  },
  {
    value: 3,
    label: '已失效'
  },
  {
    value: 4,
    label: '已取消'
  }
]
// 辅助下拉选
const aidOption = [
  {
    value: 0,
    label: '全部'
  },
  {
    value: 1,
    label: '未购买'
  },
  {
    value: 2,
    label: '已购买'
  },
  {
    value: 4,
    label: '已取消'
  }
]
const paginationConfig = {
  current: 1,
  pageSize: 20,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
}
// 工单详情
const workorderDetailConfig = [
  {
    label: '工单ID：',
    prop: 'workOrderId',
    class: ['large', 'noborder']
  },
  {
    label: '工单任务：',
    prop: 'workOrderTask',
    class: ['large', 'noborder']
  },
  {
    label: '工单类型：',
    prop: 'businessTypeDesc'
  },
  {
    label: '工单状态：',
    prop: 'workOrderStatusDesc'
  },
  {
    label: '工单完成人：',
    prop: 'completeName',
    class: ['noborder']
  },
  {
    label: '回滚次数：',
    prop: 'rollbackNumber'
  },
  {
    label: '当前处理人：',
    prop: 'acceptorName'
  },
  {
    label: '创建时间：',
    prop: 'createdAt',
    class: ['noborder']
  },
  {
    label: '首次分配时间：',
    prop: 'firstStartTime'
  },
  {
    label: '首次处理时间：',
    prop: 'firstDealTime'
  },
  {
    label: '完成时间：',
    prop: 'completeTime',
    class: ['noborder']
  },
  {
    label: '未购原因：',
    prop: 'notBuyReason',
    class: ['large', 'noborder']
  }
]

// 有些会根据工单类型判断是否显示
const labelByTypeDetailConfig = [
  {
    showBusinessType: [1, 10, 39],
    label: '完成工单结果类型：',
    prop: 'followRecordDetail'
  },
  {
    showBusinessType: [1, 10, 39],
    label: '下次跟踪时间：',
    prop: 'followRecordNextTime',
    class: ['extra', 'noborder']
  },
  {
    showBusinessType: [1, 10, 39],
    label: '备注：',
    prop: 'remark',
    class: ['large', 'noborder']
  },
  {
    showBusinessType: [22],
    label: '未复诊原因：',
    prop: 'unRevisitReasonStr',
    class: ['large', 'noborder']
  }
]

const workorderLogs = [
  {
    title: '操作时间',
    dataIndex: 'operationTime',
    key: 'operationTime',
    width: 150
  },
  {
    title: '操作账号',
    dataIndex: 'operateAccount',
    key: 'operateAccount'
  },
  {
    title: '操作行为',
    dataIndex: 'operateActionDesc',
    key: 'operateActionDesc',
    slots: { customRender: 'operateActionDesc' }
  },
  {
    title: '流转对象',
    dataIndex: 'processorName',
    key: 'processorName'
  },
  {
    title: '详情',
    dataIndex: 'newDetail',
    key: 'newDetail',
    width: 150
  }
]

export {
  columnsTodo,
  prescriptionOption,
  aidOption,
  paginationConfig,
  workorderDetailConfig,
  workorderLogs,
  labelByTypeDetailConfig
}
